import { create } from 'zustand';
import { getState, useState } from '@/framework';
import { IExportState, StateType } from '@/version-types';

/** 状态 */
interface IState {
    /** 选取的图层 id 列表 */
    pickIds: Set<string>;
    /** 是否激活 */
    isActive: boolean;
}

/** 动作 */
interface IAction {
    /** 设置选取的图层 id 列表 */
    setPickIds: (pickIds: string[], isReset?: boolean) => void;
    /** 获取选取的图层 id 列表 */
    getPickIds: () => string[];
    /** 清空选取的图层 id 列表 */
    clear: () => void;
    /** 设置是否激活 */
    setIsActive: (isActive: boolean) => void;
    /** 获取是否激活 */
    getIsActive: () => boolean;
}

/** 存储类型 */
interface IStore extends IState, IAction {}

/** 创建存储 */
const createState = (identity: string) => {
    const store = create<IStore>((set, get) => ({
        pickIds: new Set(),

        isActive: false,

        setIsActive(isActive: boolean) {
            set({ isActive });
        },

        getIsActive() {
            return get().isActive;
        },

        clear() {
            if (get().pickIds.size) {
                set({ pickIds: new Set() });
            }
        },

        getPickIds() {
            return Array.from(get().pickIds);
        },

        setPickIds(ids, isReset = false) {
            if (isReset) {
                set({ pickIds: new Set(ids) });
            } else {
                if (ids.length === 0) {
                    if (get().pickIds.size) {
                        set({ pickIds: new Set() });
                    }
                } else {
                    const pickIds = get().pickIds;
                    for (const id of ids) {
                        if (pickIds.has(id)) {
                            pickIds.delete(id);
                        } else {
                            pickIds.add(id);
                        }
                    }
                    set({ pickIds: new Set(pickIds) });
                }
            }
        },
    }));

    return store;
};

/** 存储名称 */
const name = 'group-pick-state';

/** 存储类型 */
type ModuleType = StateType<IStore, typeof name>;

/** hook 获取存储 */
export const useGroupPickState = () => {
    return useState<ModuleType>()[name];
};

/** 通过 id 获取存储 */
export const getGroupPickState = (identity: string) => {
    return getState<ModuleType>(identity)[name].getState();
};

const exportState: IExportState = {
    name,
    createState,
};

export default exportState;
